var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivitesCompte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 64c-11.789 0-22.592-6.454-28.189-16.842-0.419-0.778-0.128-1.747 0.65-2.166s1.747-0.128 2.166 0.65c5.037 9.35 14.758 15.158 25.37 15.158 15.882 0 28.8-12.918 28.8-28.8s-12.918-28.8-28.8-28.8c-10.57 0-20.275 5.776-25.325 15.072-0.381 0.698-1.216 1.014-1.962 0.736s-1.174-1.059-1.008-1.837l2.73-12.71c0.186-0.864 1.037-1.414 1.901-1.229s1.414 1.037 1.229 1.901l-1.117 5.194c5.984-6.502 14.48-10.33 23.552-10.33 8.547 0 16.582 3.328 22.627 9.373s9.373 14.080 9.373 22.627c0 8.547-3.328 16.582-9.373 22.627s-14.080 9.373-22.627 9.373l0.003 0.003z",
    fill: "#223654"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 33.6c-0.269 0-0.534-0.067-0.778-0.202l-14.4-8c-0.771-0.429-1.050-1.402-0.621-2.176s1.402-1.050 2.176-0.621l13.568 7.536 16.797-10.688c0.746-0.474 1.734-0.256 2.208 0.49s0.256 1.734-0.49 2.208l-17.6 11.2c-0.262 0.166-0.56 0.25-0.858 0.25l-0.003 0.003z",
    fill: "#223654"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitesCompte);
export default __webpack_public_path__ + "static/media/activites-compte.c4282afff3d9f95baaa0948e0013799a.svg";
export { ForwardRef as ReactComponent };